import type { ICodeQuery } from './ICodeQuery';

const CODE = /^([\p{L}]{2,10})\s*-?\s*(\d{1,9})$/u;

/** Розбирає запит як код запису (префікс + номер, з дефісом чи без); інший запит — null. Чиста функція. */
export function parseCodeQuery(q: string): ICodeQuery | null {
  const m = CODE.exec(q.trim());
  return m ? { prefix: m[1]!.toUpperCase(), code: Number(m[2]) } : null;
}
